export type GridPhoto = {
  id: string;
  url: string;
  makeUrl: (url: string, width: number, height: number) => string;
  resizeUrl?: string;
  originalUrl?: string;
  title?: string;
};
